import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AccountFacade } from "@youm-front/account/data-access";
import { of } from "rxjs";
import {
  catchError,
  filter,
  map,
  mergeMap,
  tap,
  timeout
} from "rxjs/operators";

@Injectable()
export class DefaultRoomGuard {
  constructor(
    private readonly router: Router,
    private readonly accountFacade: AccountFacade
  ) {}

  canActivate() {
    return this.accountFacade.authorized$.pipe(
      tap((_) => (_ ? null : this.accountFacade.redirectToAuth())),
      mergeMap((_) =>
        !_
          ? of(false)
          : this.accountFacade.defaultRoomPid$.pipe(
              filter((_) => !!_),
              // Wait until default room data loaded
              timeout(15_000)
            )
      ),
      tap((_) => (_ ? null : this.accountFacade.redirectToAuth())),
      map((_) => (_ ? this.router.createUrlTree([_]) : _)),
      mergeMap((_) => (_ ? this.router.navigateByUrl(_) : of(false))),
      catchError(() => {
        this.accountFacade.redirectToAuth();
        return of(false);
      })
    );
  }
}
